var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"achievement"}},[_c('div',{staticClass:"title"},[_c('p',[_vm._v("成绩信息："+_vm._s(_vm.is_open.fraction))]),_c('p',[_vm._v("录取信息："+_vm._s(_vm.is_open.enter))])])])}
var staticRenderFns = []

export { render, staticRenderFns }